import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import axios from 'axios';

import { 
  Button, 
  Dialog, 
  ListItem, 
  ListItemText,
  List, 
  //Divider, 
  AppBar, 
  Toolbar, 
  IconButton, 
  Typography, 
  Slide,
  TextField,
  MenuItem,
  Backdrop,
  //DialogContent,
  //Box,
  Card,
  CardHeader,
  //CardActions,
  Paper,
  CardContent,
  CircularProgress
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { templateTypes } from 'common/datas';
import { IsNoU } from 'common/utils';


const useStyles = makeStyles(theme => ({
    root: {
      backgroundColor: theme.palette.background.default,
      height: '100%',
      //margin: theme.spacing(1),
      //padding: theme.spacing(3)
    },
    card_root: {
      //padding: theme.spacing(3)
    },
    row: {
      height: '62px',
      display: 'flex',
      alignItems: 'center',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    content: {
      //marginTop: theme.spacing(2)
      flex: 0,
      width: 320,
    },
    list_height: {
      height: 320,
    },
    appBar: {
      position: 'relative',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    card_header: {
      backgroundColor: theme.palette.card_header,
    },
    listitem_align: {
      //alignItems: 'center',
    },
    registerListItemTitle: {
      marginLeft: theme.spacing(2),
      width: '120px',
      //height: '100%',
      //backgroundColor: theme.palette.card_header,
      // flexDirection: "column",
      // justifyContent: "center"
    },
    registerListItemInput: {
      //marginLeft: theme.spacing(2),
      width: '360px',
      //height: '40px',
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));
  


const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});


const EditOrderCategory = (props) => {

  const classes = useStyles();

  const {
    className, 
    openDialog,
    onClickCloseDialog,
    onClickSaveDialog,

    categories,
    ...rest
  } = props;

  const [updateOrderList, setUpdateOrderList] = useState(false);
  const [newOrderCategories, setNewOrderCategories] = useState([]);
  const [selectedIndexOrder, setSelectedIndexOrder] = useState(-1);
  const handleListClickOrder = (e, index) => {
    setSelectedIndexOrder(index);
  };

  const handleClickOrderUp = () => {
    if (selectedIndexOrder === -1 || 
      (selectedIndexOrder < 0 && selectedIndexOrder >= newOrderCategories.length)) {
      return ;
    }

    if (selectedIndexOrder === 0)
      return ;

    let prevIndexOrder = selectedIndexOrder-1;
    let newOrders = newOrderCategories;

    let tempOrder = newOrders[prevIndexOrder];
    newOrders[prevIndexOrder] = newOrders[selectedIndexOrder];
    newOrders[selectedIndexOrder] = tempOrder;

    setSelectedIndexOrder(prevIndexOrder);
    setNewOrderCategories(newOrders);
    //updateListAni();
  }

  const handleClickOrderDown = () => {
    if (selectedIndexOrder === -1 || 
      (selectedIndexOrder < 0 && selectedIndexOrder >= newOrderCategories.length)) {
      return ;
    }

    if (selectedIndexOrder === newOrderCategories.length-1)
      return ;

    let prevIndexOrder = selectedIndexOrder+1;
    let newOrders = newOrderCategories;

    let tempOrder = newOrders[prevIndexOrder];
    newOrders[prevIndexOrder] = newOrders[selectedIndexOrder];
    newOrders[selectedIndexOrder] = tempOrder;

    setSelectedIndexOrder(prevIndexOrder);
    setNewOrderCategories(newOrders);
  }

  const handleClickOrderTop = () => {
    if (selectedIndexOrder === -1 || 
      (selectedIndexOrder < 0 && selectedIndexOrder >= newOrderCategories.length)) {
      return ;
    }

    if (selectedIndexOrder === 0)
      return ;

    let prevIndexOrder = 0;
    let newOrders = newOrderCategories;

    let tempOrder = newOrders[prevIndexOrder];
    newOrders[prevIndexOrder] = newOrders[selectedIndexOrder];
    newOrders[selectedIndexOrder] = tempOrder;

    setSelectedIndexOrder(prevIndexOrder);
    setNewOrderCategories(newOrders);
  }

  const handleClickOrderLast = () => {
    if (selectedIndexOrder === -1 || 
      (selectedIndexOrder < 0 && selectedIndexOrder >= newOrderCategories.length)) {
      return ;
    }

    if (selectedIndexOrder === newOrderCategories.length-1)
      return ;

    let prevIndexOrder = newOrderCategories.length-1;
    let newOrders = newOrderCategories;

    let tempOrder = newOrders[prevIndexOrder];
    newOrders[prevIndexOrder] = newOrders[selectedIndexOrder];
    newOrders[selectedIndexOrder] = tempOrder;

    setSelectedIndexOrder(prevIndexOrder);
    setNewOrderCategories(newOrders);
  }

  const updateListAni = () => {
    setUpdateOrderList(true);
    setTimeout(() => { //Start the timer
      setUpdateOrderList(false); //After 1 second, set render to true
    }, 100);
  }


  useEffect(() => {
    
    setNewOrderCategories(categories);

  }, [categories]);

  const renderCategoryList = (
    <>
      {updateOrderList === false && (
        newOrderCategories.map((category, index) => (
          <ListItem 
            key={category.id} 
            button
            selected={selectedIndexOrder === index}
            onClick={(e) => handleListClickOrder(e, index)}
          >
            <ListItemText primary={category.name} />
          </ListItem>
        )
      ))}
    </>
  );

  return (
    <Dialog 
      fullScreen open={openDialog} 
      onClose={onClickCloseDialog} 
      TransitionComponent={Transition}
    >
    <AppBar className={classes.appBar}>
      <Toolbar>
        <IconButton edge="start" color="inherit" onClick={onClickCloseDialog} aria-label="close">
          <CloseIcon />
        </IconButton>
        <Typography variant="h5" className={classes.title} color="inherit">
          카테고리
        </Typography>
        <Button color="inherit" onClick={() => onClickSaveDialog(newOrderCategories)}>
          저장
        </Button>
      </Toolbar>
    </AppBar>

    <div className={classes.root}>

    <List>
      <ListItem className={classes.listitem_align}>
      <Card
        className={clsx(classes.card_root, className)}
      >
        <CardHeader
          className={classes.card_header}
          title={'카테고리 순서'}
        />
        <CardContent className={classes.content}>
        <Paper style={{width: 320, height: 240, overflow: 'auto'}}>
          <List>
            {/* {[0,1,2,3,4,5,6,7,8,9].map(category => (
              <ListItem key={category} button className={classes.listitem_align}>
                <ListItemText primary={category} />
              </ListItem>
            ))} */}
            { renderCategoryList }
            </List>
          </Paper>
        </CardContent>
        </Card>
      </ListItem>

      <ListItem>
      <div className={classes.row} spacing={0}>
            <Button
              color="primary"
              variant="contained"
              onClick={ handleClickOrderUp }
            >
              위로
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={ handleClickOrderDown }
            >
              아래로
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={ handleClickOrderTop }
            >
             제일 위로
            </Button>

            <Button
              color="primary"
              variant="contained"
              onClick={ handleClickOrderLast }
            >
              제일 아래로
            </Button>

          </div>
      </ListItem>
    </List>
    {/* </form> */}

    </div>
  
  </Dialog>
  );
}


EditOrderCategory.propTypes = {
  className: PropTypes.string,
  categories: PropTypes.array.isRequired,
};

EditOrderCategory.defaultProps = {
  categories: [],
};



export default EditOrderCategory;